import React from "react";

import RelationshipsScreen from "./Components/RelationshipsScreen";

import { type AppUserSession } from "@/schemas/auth/session";
import { RelationshipType } from "@/schemas/user/relationship";

type Props = {
  session: AppUserSession;
  username: string;
};

function FollowingsScreen({ session, username }: Props): React.JSX.Element {
  return (
    <RelationshipsScreen
      session={session}
      username={username}
      relationshipType={RelationshipType.FOLLOWING}
    />
  );
}

export default FollowingsScreen;
